import React, { Component } from 'react'

class DesignationView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data
        }
    }
    render() {
        const { data } = this.state;
        return (
            <div className="container" style={{ marginTop: 20 }}>
                <div className='row'>
                    <form id="check_form">
                        <div className="row">
                            <div className="form-group col-md-4">
                                <div><label htmlFor="designation" className="col-sm-12">Designation</label></div>
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        className="form-control input-md"
                                        value={data.designations || ''}
                                        disabled />
                                </div>
                            </div>
                            <div className="form-group col-md-4">
                                <div><label htmlFor="career_level" className="col-sm-12">Level</label></div>
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        id='career_level'
                                        className="form-control input-md"
                                        value={data.career_level || ''}
                                        disabled />
                                </div>
                            </div>
                            <div className="form-group col-md-4">
                                <div><label htmlFor="department" className="col-sm-12">Department</label></div>
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        className="form-control input-md"
                                        value={data.deptname || ''}
                                        disabled />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="form-group col-md-4">
                                <div><label htmlFor="staff_category_name" className="col-sm-12">Staff Category</label></div>
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        id='staff_category_name'
                                        className="form-control input-md"
                                        value={data.staff_category_name || ''}
                                        disabled />
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <div><label htmlFor="remark" className="col-sm-12">Remark</label></div>
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        id='remark'
                                        className="form-control"
                                        value={data.remark || ''}
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-2">
                                <div><label htmlFor="active" className="col-sm-12 text-center">Active</label></div>
                                <div className="col-sm-12">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 34 }}>
                                        <input
                                            type="checkbox"
                                            id={'active'}
                                            checked={data.active === 0 ? false : true}
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default DesignationView
